import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EGetNotificationsListActionTypes, TGetNotificationsListLoading } from './types';

export const getNotificationsListLoading: () => TGetNotificationsListLoading =
  actionGenerator<EGetNotificationsListActionTypes.Loading>(EGetNotificationsListActionTypes.Loading);
